import React, { useEffect, useState } from 'react'
import brandDomains from 'src/config/hostConfig';
import { withAppContext } from 'src/store/initAppContext';
import { withTheme } from 'styled-components';

const MainContent = (props) => {
    const { app: { brandId }, theme } = props;
    let findDomain = brandDomains.find(elm => elm.id === brandId)?.domain;
    const website = `${findDomain}`;
    const [mailId, setMailId] = useState('')
    const name = website.toUpperCase().split('.')[1]

    useEffect(() => {
        switch (brandId) {
            case 31:
                setMailId('support@yolo247.site')
                break;
            case 32:
                setMailId('support@yolo247.club')
                break;
            case 33:
                setMailId('support@iw247.com')
                break;
            case 34:
                setMailId('support@betdaily.club')
                break;
            case 46:
                setMailId('support@fun88.site')
                break;
            case 47:
                setMailId('support@gofun88.in')
                break;
            default:
                setMailId('')
                break;

        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const { config: { showSkypeId ,showResgambling} } = theme;

    return (
        <div className='policyInternWrap'>
            <h1>Gambling with responsibility</h1>
            {/* <div className='downloadAction'>
                <a href={policyDwnldLink} target="_blank"><PolicyDwnldIcon />Download</a>
            </div> */}
            <p>Last updated: 09/06/2022</p>
            <p>
                Please read this information carefully for your own benefit.
            </p>

            <h1>Interpretation</h1>

            <p>The words of which the initial letter is capitalized have meanings defined under the following
                conditions.</p>
            <p>The following definitions shall have the same meaning regardless of whether they appear in
                singular or in plural.</p>

            <h1>Definitions</h1>

            <p>For the purposes of these Terms and Conditions:</p>
            <ul>
                <li>Account means a unique account created for You to access our Service or parts of our
                    Service.</li>
                <li>Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement)
                    refers to Co</li>
                <li>Service refers to the Website.</li>
                <li>Website refers to <a href={`http://${website}`} rel="noreferrer" target="_blank" style={{ 'textTransform': 'none' }}>{website}</a></li>
                <li>You means the individual accessing or using the Service, or the company, or other legal
                    entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
            </ul>
            <h1>Responsible Gambling and Self Exclusion</h1>

            <p>Gambling means for the majority of our Users, entertainment, fun and excitement. But we
                also know that for some of our Users gambling has negative side effects. In the medical
                science is pathologic gambling since many years as serious sickness recognised.</p>

            <p>Since our first day we think about this problematic and try out best to help. Under
                “Responsible Gambling” We understand multiple steps of measures, with which a gambling
                provider can help to lower the possibility of negative side effects appearing. -In case they
                already appear we also try to take active steps against them.</p>

            <p>The most important instrument against negative side effects from gambling are knowledge
                and education about the risks of gambling too support our Users self-control in order to make
                sure they do not suffer from negative side effects.</p>

            <h1>Information and contact</h1>

            {/* <p>Our Support will help you via email at all time without any additional costs for you:</p>
            <ul>
                <li><a href={`mailto:http://www.${mailId}`} style={{ textTransform: 'none' }}>{mailId}</a></li>
            </ul> */}
            <p>Our Support will of course not give out any information about You without Your consent to
                anyone else</p>

            <p>In addition you also can take a self-test, if You are already gambling addicted at: <a style={{ textTransform: "none" }} href="https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/">https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/</a>
            </p>

            <p>And you can also find additional information about gambling addictions at: <a style={{ textTransform: "none" }} href="https://www.begambleaware.org/safer-gambling/">https://www.begambleaware.org/safer-gambling/</a>
            </p>

            <h1>Helpful hints for responsible gambling at <a href={`http://${website}`} rel="noreferrer" target="_blank" style={{ 'textTransform': 'none' }}>{website}</a></h1>

            <p>We recommend you think about the following hints, before gambling in order to insure
                gambling stays fun for You and without any negative side effects:</p>
            <ul>
                <li>Set yourself a deposit limit<br />
                    Before you start to gambling think about how much you can afford to gamble with
                    according to Your financial situation. Play with amounts which are for fun and for Your
                    entertainment</li>

                <li>Do not try to win back a loss at every cost<br />
                    Try to not take to huge risks to win back what You lost before at any cost. Play for
                    Entertainment and not to earn money.</li>

                <li>Set yourself a time limit <br />
                    Set yourself a time limit and do not break it. Keep in mind gambling should stay in
                    balance with your other hobbies and not be Your only hobby.</li>

                <li>Play smart:<br />
                    It is smarter to not play, when You are extremely stressed, depressed or under to
                    much pressure. Also do not play when you are under the influence of Medications,
                    Drugs or Alcohol.</li>

                <li>Take breaks:<br />
                    You should take breaks when You notice, that You get tired or can&apos;t concentrate
                    anymore</li>

                <li>Only one account:<br />
                    To make it easier to have an overview how much time and money You spend on
                    gambling it is highly advised to not create more than one Account per Person.</li>
            </ul>

            <h1>Minor Protection</h1>

            <p>To use our Service, You have to be 18 years or older. To avoid abuse, keep Your login data
                save from any minors near You.</p>

            <p>Principally we recommend a filter program to avoid minors, especially children, to access any
                context on the internet, which is not healthy for them.</p>

            <p>For parents we can recommend a list of internet filters, to support them, from keeping their
                children from any context, which was not made for them:</p>

            <a style={{ textTransform: "none" }} href="https://famisafe.wondershare.com/internet-filter/best-internet-filters.html">https://famisafe.wondershare.com/internet-filter/best-internet-filters.html</a>

            <h1>Self-Exclusion:</h1>

            <p>In case You are diagnosed with a gambling addiction or try to stay away from gambling for a
                different reason, we want to assist you to stay away from anything, that does nothing good
                for you. “Self-Exclusion” means, that You exclude yourself, out of Your own choice, from all
                gambling services. This exclusion cannot be undone for a set amount of time. If you wish to
                self-exclude yourself from gambling, please message our support and give them a time span
                between 6 months and 5 years. They also will explain you all future steps and what is
                needed from you.</p>

            {/* <ul>
                <li>email: <a href={`mailto:http://www.${mailId}`} style={{ textTransform: 'none' }}>{mailId}</a></li>
            </ul> */}

            <p>Please keep in mind that Self Exclusion is permanent for the set time span and will not be
                undone for your own protection.</p>

            <p>During Self Exclusion you are not allowed to create a new Account and every attempt to
                create a new Account during Self Exclusion is a violation of our Terms of Service and may
                result in the permanent ban of your original account.</p>

            {showResgambling ?
                <>
                <h2 className='addColor'>Responsible Gaming</h2>
                <p><span className='brandColor'>{name}</span> is here to provide an excellent and enjoyable gaming experience and recognize our responsibility in preventing problematic activity. We advise all players to take into account the following, and not game irresponsibly&#58;</p>
                <ul>
                    <li>Play for entertainment, not to make money.</li>
                    <li>Avoid chasing losses.</li>
                    <li>Establish limits for yourself.</li>
                    <li>Do not let gambling interfere with your daily responsibilities.</li>
                    <li>Never gamble unless you can cover losses.</li>
                    <li>Take breaks.</li>
                </ul>
                <p>See the below questions. If your answer to the majority of them is &quot;YES&quot;, we advise you take action to prevent gambling from negatively impacting your life&#58;</p>

                <ul>
                    <li>Does gambling affect your work?</li>
                    <li>Has gambling caused arguments with family/friends?</li>
                    <li>Do you always return to win back your losses?</li>
                    <li>Have you borrowed money to gamble?</li>
                    <li>Do you see gambling as a source of income?</li>
                    <li>Do you find it difficult to limit your gambling?</li>
                </ul>

                <h2 className='addColor'>What to do?</h2>
                <p>Listed below are reputed organizations committed to helping those who struggle with gambling problems, and can be contacted at any time&#58;</p>

                <ul>
                    <li><a href='https://www.gamblersanonymous.org/ga/'>Gamblers Anonymous</a></li>
                    <li><a href='https://www.gamblingtherapy.org/'>Gambling Therapy</a></li>
                    <li><a href='https://www.gamcare.org.uk/'>GamCare</a></li>
                </ul>

                <h2 className='addColor'>How we can help?</h2>
                <p>We advise all players who are concerned about their gambling behavior to take a break by excluding themselves from their gaming account. Self-exclusion will lock your account for a minimum of 6 months and no promotional material will be sent.<br />
                    Contact our experienced Customer Support team at any time to request this and they will kindly assist you. A 7 day cooling off period is also available. We recommend that you contact all other gambling sites where you have an account and request self-exclusion there also.</p>

                <h2 className='addColor'>Underage gambling</h2>
                <p>Players must be of legal gambling age in their jurisdiction (at least 18+) in order to play at Site Name. It is their responsibility to be aware of the age restriction where they reside and play, and to confirm their legitimacy when creating an account at Site Name. We also advise parents to do the following&#58;</p>

                <ul>
                    <li>Password protect computer, mobile, and/or tablet.</li>
                    <li>Do not leave device unattended when logged into your account.</li>
                    <li>Make sure all account details and credit cards are inaccessible to children.</li>
                    <li>Do not save passwords on your computer, write them down and keep somewhere out of reach.</li>
                    <li>Download filtering software (e.g.<a href='https://www.netnanny.com/'><span className='brandColor'>Net Nanny</span></a>) to prevent minors from accessing inappropriate sites.</li>
                </ul> </> : null 
            }
        </div>
    )
}

export default withAppContext(withTheme(MainContent));